// extracted by mini-css-extract-plugin
module.exports = {"mobileBioIntakeWrapper":"MobileBioIntake_mobileBioIntakeWrapper__3qh74"};